const enTranslation = {
  goToSenecaLearning: "Go to Seneca Learning 📚",
  continueWithProvider: "Continue with {{provider}}",
  redirectBackToTheApp: "Redirect back to the app",
};

export default enTranslation;
